<template>
  <div class="support_contacts" v-if="isNewHome">
    <div class="support_contacts_support">
      <div class="support_contacts_support-button -telegram" @click="openTelegram">
        <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_18923_5901)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.94364 8.74888C8.58077 6.20867 12.3397 4.534 14.2206 3.72489C19.5907 1.4147 20.7065 1.01339 21.4338 1.00014C21.5938 0.997227 21.9514 1.03823 22.1831 1.23267C22.3787 1.39685 22.4326 1.61863 22.4583 1.77429C22.4841 1.92995 22.5162 2.28455 22.4907 2.56163C22.1997 5.7241 20.9405 13.3986 20.2999 16.9406C20.0288 18.4394 19.4951 18.9419 18.9784 18.9911C17.8554 19.098 17.0027 18.2235 15.9151 17.4861C14.2132 16.3323 13.2517 15.614 11.5997 14.488C9.69056 13.1868 10.9282 12.4716 12.0162 11.3027C12.301 10.9969 17.2486 6.34226 17.3444 5.92001C17.3564 5.86721 17.3675 5.67036 17.2544 5.56642C17.1414 5.46248 16.9745 5.49802 16.8541 5.52629C16.6834 5.56636 13.9646 7.42501 8.69761 11.1022C7.92588 11.6503 7.22687 11.9174 6.60058 11.9034C5.91015 11.888 4.58204 11.4996 3.59473 11.1677C2.38374 10.7606 1.42128 10.5453 1.50509 9.85385C1.54874 9.4937 2.02826 9.12538 2.94364 8.74888Z" fill="white"/>
          </g>
          <defs>
            <clipPath id="clip0_18923_5901">
              <rect width="22" height="22" fill="white" transform="translate(0.5)"/>
            </clipPath>
          </defs>
        </svg>
        <span>{{ $t('techSupportIn', { service: 'Telegram' }) }}</span>
        <span/>
      </div>

      <div class="support_contacts_support-button -whatsapp" @click="openWhatsapp">
        <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_18923_5906)">
            <path d="M1 22L2.5538 16.3506C1.59499 14.6969 1.09118 12.8223 1.0921 10.9001C1.09487 4.89042 6.00862 0 12.0461 0C14.9759 0.000916667 17.7261 1.13667 19.7948 3.19733C21.8625 5.258 23.0009 7.997 23 10.9102C22.9972 16.9208 18.0835 21.8112 12.0461 21.8112C10.2132 21.8103 8.40702 21.3528 6.80717 20.4838L1 22ZM7.07611 18.5103C8.61978 19.4223 10.0934 19.9687 12.0424 19.9696C17.0602 19.9696 21.1478 15.9051 21.1505 10.9083C21.1524 5.9015 17.0841 1.8425 12.0497 1.84067C7.02822 1.84067 2.9434 5.90517 2.94156 10.901C2.94063 12.9406 3.54115 14.4677 4.54969 16.0655L3.62957 19.4095L7.07611 18.5103ZM17.564 13.5016C17.4959 13.3879 17.3135 13.3201 17.039 13.1835C16.7655 13.0469 15.4198 12.3878 15.1684 12.2971C14.9179 12.2063 14.7355 12.1605 14.5522 12.4337C14.3698 12.7059 13.8448 13.3201 13.6855 13.5016C13.5262 13.6831 13.3659 13.706 13.0924 13.5694C12.8188 13.4328 11.9364 13.1459 10.8911 12.2173C10.0778 11.495 9.52792 10.6031 9.36858 10.3299C9.20924 10.0577 9.352 9.91008 9.48832 9.77442C9.61174 9.6525 9.76187 9.45633 9.8991 9.29683C10.0382 9.13917 10.0833 9.0255 10.1754 8.84308C10.2666 8.66158 10.2215 8.50208 10.1524 8.3655C10.0833 8.22983 9.53621 6.88875 9.30872 6.34333C9.08582 5.81258 8.86017 5.88408 8.69254 5.87583L8.16755 5.86667C7.98518 5.86667 7.6886 5.9345 7.43808 6.20767C7.18756 6.48083 6.4802 7.139 6.4802 8.48008C6.4802 9.82117 7.46111 11.1164 7.59742 11.2979C7.73466 11.4794 9.527 14.2313 12.2726 15.411C12.9256 15.6915 13.4359 15.8593 13.8329 15.9848C14.4887 16.192 15.0855 16.1627 15.5571 16.093C16.083 16.0151 17.1763 15.4339 17.4047 14.7978C17.6331 14.1607 17.6331 13.6153 17.564 13.5016Z" fill="white"/>
          </g>
          <defs>
            <clipPath id="clip0_18923_5906">
              <rect width="22" height="22" fill="white" transform="translate(0.5)"/>
            </clipPath>
          </defs>
        </svg>
        <span>{{ $t('techSupportIn', { service: 'WhatsApp' }) }}</span>
        <span/>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useStore } from '@web/store'
import useSupportContacts from '@web/composition/useSupportContacts'

export default defineComponent({
  name: 'AsMenuContacts',
  setup () {
    const store = useStore()
    const {
      openWhatsapp,
      openTelegram
    } = useSupportContacts()

    const isNewHome = computed(() => store.getters['stream/getIsSpecialStream'])

    return {
      isNewHome,
      openWhatsapp,
      openTelegram
    }
  }
})
</script>

<style lang="scss">
.support_contacts {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-end;
  flex: 1 1 auto;
  padding: 22px 20px;
  width: 100%;

  &_support {
    display: flex;
    flex-direction: column;
    gap: 12px;
    color: var(--ac-color-white);
    width: 100%;

    &-button{
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      width: 100%;
      padding: 14px;
      border-radius: 32px;
      height: 50px;
      cursor: pointer;
      text-decoration: none;

      &.-telegram {
        background-color: #28A8E8;
      }
      &.-whatsapp {
        background-color: #25D366;
      }

      svg {
        width: 22px;
        height: 22px;
        flex-shrink: 0;
      }

      span {
        font-family: Inter;
        font-weight: 400;
        font-size: 16px;
        line-height: 130%;
        white-space: nowrap;
        color: var(--ac-color-white);

        &:empty {
          width: 22px;
          flex-shrink: 0;
        }
      }
    }
  }
}
</style>
